import React, { useCallback } from "react";
import { ReactSVG } from "react-svg";
import { useEnvContext } from "@gw/env-context";
import { imgs } from "@gw/theming";
import { TLoaderButtonState } from "./LoaderButtonTypes";
import { LoaderButtonStyled } from "./LoaderButtonStyled";
var LoaderButton = function (_a) {
    var children = _a.children, _b = _a.state, state = _b === void 0 ? TLoaderButtonState.Normal : _b, _c = _a.className, className = _c === void 0 ? "" : _c, onClick = _a.onClick;
    var imgsFolder = useEnvContext().imgsFolder;
    var handleClick = useCallback(function (ev) {
        if (state === TLoaderButtonState.Normal) {
            if (!!onClick) {
                onClick(ev);
            }
        }
    }, [state, onClick]);
    return (React.createElement(LoaderButtonStyled, { className: className + " loader-btn-state-" + state, onClick: handleClick, disabled: state !== TLoaderButtonState.Normal },
        React.createElement("span", { className: "loader" },
            React.createElement(ReactSVG, { src: imgsFolder + "/" + imgs.icons.loaderThreeDots })),
        React.createElement("span", { className: "children" }, children)));
};
export default LoaderButton;
//# sourceMappingURL=LoaderButton.js.map